import React, { useEffect, useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import InputMask from 'react-input-mask';

const PhoneInput = ({ label, name, register, errors, rules = {}, placeholder = "Digite o telefone", value = '' }) => {
  const [mask, setMask] = useState('');
  const [key, setKey] = useState(0);
  const isKeySet = useRef(false);

  useEffect(() => {
    const numericValue = value.replace(/\D/g, '');
    setMask(numericValue.length <= 10 ? '(99) 9999-9999' : '(99) 99999-9999');

    if (!isKeySet.current && value !== '') {
      setKey((prevKey) => prevKey + 1);
      isKeySet.current = true;
    }
  }, [value]);

  const handleKeyDown = (e) => {
    const digit = e.key.replace(/\D/g, '');
    const currentValue = e.target.value.replace(/\D/g, '');
    const size = currentValue.concat(digit).length;

    setMask(size <= 10 ? '(99) 9999-9999' : '(99) 99999-9999');
  };

  return (
    <Form.Group controlId={name} className="mb-3">
      {label && <Form.Label className="mb-1">{label}</Form.Label>}
      <InputMask
        key={key}
        mask={mask}
        maskChar={null}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        defaultValue={value}
        autoComplete='off'
        {...register(name, {
          ...rules,
          validate: (value) => {
            const numericValue = value.replace(/\D/g, '');
            if (numericValue.length === 0 || numericValue.length >= 10) {
              return true;
            }
            return 'Telefone inválido.';
          },
        })}
      >
        {(inputProps) => (
          <Form.Control
            {...inputProps}
            className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
          />
        )}
      </InputMask>
      {errors[name] && <Form.Control.Feedback type="invalid">{errors[name].message}</Form.Control.Feedback>}
    </Form.Group>
  );
};

export default PhoneInput;